import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalHeader, ModalTitle, ModalFooter } from 'react-bootstrap';
import './Modal.scss';

const ModalComponent = (props) => {
    return(
        <Modal
            className="modal-dialog"
            onHide={props.onHide}
            show={props.show}>
            <ModalHeader
                closeButton>
                <ModalTitle>{props.modalTitle}</ModalTitle>
            </ModalHeader>
            <ModalBody
                className="modal-body">
                {props.children}
            </ModalBody>
            {props.modalFooter &&
            <ModalFooter>
                <p>{props.modalFooter}</p>
            </ModalFooter>}
        </Modal>
    );
};

ModalComponent.propTypes = {
    children: PropTypes.node,
    onHide: PropTypes.func,
    modalTitle: PropTypes.string,
    modalFooter: PropTypes.string,
    show: PropTypes.bool
};

export default ModalComponent;


// WEBPACK FOOTER //
// ./src/components/base/Modal/Modal.js